export const packages=[
    {
        id:1,
        value:'1 hrs 10 kms'
    },
    {
        id:2,
        value:'2 hrs 20 kms'
    },
    {
        id:3,
        value:'3 hrs 30 kms'
    },
    {
        id:4,
        value:'4 hrs 40 kms'
    },
    {
        id:5,
        value:'5 hrs 50 kms'
    },
    {
        id:6,
        value:'6 hrs 60 kms'
    },
    {
        id:7,
        value:'7 hrs 70 kms'
    },
    {
        id:8,
        value:'8 hrs 80 kms'
    },
    {
        id:9,
        value:'9 hrs 90 kms'
    },
    {
        id:10,
        value:'10 hrs 100 kms'
    },
    {
        id:11,
        value:'11 hrs 110 kms'
    },
    {
        id:12,
        value:'12 hrs 120 kms'
    }
]